var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-button c-button--default"},[_c('img',{staticClass:"c-button__left-icon",attrs:{"src":_vm.assetsPath('emblem-white.svg'),"alt":""}}),_vm._v("\n  Follow on Airbit\n")])}
var staticRenderFns = []

export { render, staticRenderFns }